
import Dropzone from "dropzone";
import noUiSlider from "nouislider";

export default {
  name: 'ImageEnlarger',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
          "@type": "Question",
          "name": "What is an Image enlarger, and why do I need it?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "An online image enlarger is a tool that helps you enlarge photos. It also has many features to serve multiple purses. In general, you will want to use it when: You have taken low-quality images, and the tool can automatically enhance their image resolution. You need a tool to increase your image size. Your product images require better resolution. You are not good at manual editing."
          }
      },{
          "@type": "Question",
          "name": "Why should I increase the definition of images?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Maybe you got the incorrect file sizes from the image website, used a poor camera, or took the photos in low-light conditions. Regardless of the reasons, you can't use these photos on your website because they would ruin your reputation and discourage visitors from browsing. Improving the image definition is critical in these cases, especially for businesses and websites that demand professional looks."
          }
      },{
          "@type": "Question",
          "name": "Can the image enlarger tool enlarge images without losing quality?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "It depends on which tool you use. But luckily, most image enlargers can upscale and enhance images. After inserting the picture you want to enlarge, the enlarger often asks you to choose the image size and quality you wish to have. It's where you can guarantee that your upscaled picture will have good quality at the desired size."
          }
      },{
          "@type": "Question",
          "name": "Are original images lost when enlarged?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "It depends on whether you save your enlarged images as new files. We recommend keeping a copy version of the picture you want to enlarge. Then, use it to replace the original photo."
          }
      },{
          "@type": "Question",
          "name": "Which is the best file format for enlarging images?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Although PNG and JPEG are frequently used formats, vector images are the most straightforward files to resize."
          }
      }]
    };
  },
  head() {
    return {
        link: [
            { rel: 'stylesheet', href: '/assets/css/vendors.min.css' }
        ]
    }
  },
  data() {
    return {
        filesSelected: 0,
        local_image: null,
        progress: 0,
        loading: false,
        isActive: false,
        percentage: 0,
        imageWidth: 640,
        imageHeight: 427,
        imageWidthFinal: 640,
        imageHeightFinal: 427,
        form: this.$vform({ })
    };
  },
  mounted() {

        Dropzone.autoDiscover = false;

        let vm = this;

        var errors = false;

        var myDropzone = new Dropzone(".dropzone", { 
           maxFilesize: 5,
           autoProcessQueue: false,
           maxFiles:1,
           acceptedFiles: "image/*",
           previewsContainer: false,
           thumbnailWidth: null,
           thumbnailHeight: null,
           addedfile: function (file) {
                errors = false;
                if (this.files.length > 1) {
                    this.removeFile(this.files[0]);
                }
           },
           error: function (file, message) {
                this.removeFile(file);
                alert(message);
                errors = true;
           },
           thumbnail: function(file, dataUrl) {

                if(errors) return;

                vm.imageWidth = file.width;
                vm.imageHeight = file.height;
                vm.onSetPercentage( vm.percentage );
                vm.onSetImageData( dataUrl) ;

                // start file reader
                let result = document.querySelector('#preview-image'), cropper = '';
                const reader = new FileReader();
                reader.onload = (e)=> {
                    // create new image
                    let img          = document.createElement('img');
                    img.id           = 'image';
                    img.className    = 'img-fluid';
                    img.src          = dataUrl;
                    result.innerHTML = '';
                    result.appendChild(img);
                };
                reader.readAsDataURL(file);
           }
        });

        var slider = document.getElementById('slider');

        noUiSlider.create(slider, {
            start: [0],
            connect: true,
            step: 1,
            range: {
                'min': 100,
                'max': 500
            },
            format: wNumb({
                decimals: 0
            })
        });

        slider.noUiSlider.on('update', function (values, handle) {
            vm.onSetPercentage( values[handle] );
        });
  },
  methods: {
    onConvertType: function() {
      this.isActive = !this.isActive;
    },
    handleFileChange(event) {
        this.progress      = 0;
        this.filesSelected = event.target.files.length;
        this.local_image   = event.target.files[0];
    },
    onImageEnlarger() {

        this.progress = 0;

        const config = {
          onUploadProgress: (progressEvent) => this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        };

        const data = new FormData();

        data.append('local_image', this.local_image);
        data.append('width', this.imageWidthFinal);
        data.append('height', this.imageHeightFinal);

        this.loading = true;

        this.$axios.post(`/tool/image-enlarger`, data, config, { headers: { 'Content-Type': 'multipart/form-data', 'Accept': 'multipart/form-data' } }).then(res => {
           
            jQuery('.download-image').attr( 'href',  res.data.download );

            jQuery('.preview-download-image').attr('src', res.data.preview);

            jQuery('#modalPreviewDownloadImage').modal('show');

        }).catch(e => {

          this.form.errors.set(e.response.data.errors);

        }).finally(() => {

          this.loading = false

       });

    },
    onSetImageData( imageData ){
        this.local_image = imageData;
    },
    onSetPercentage( value ){
        this.percentage       = Math.floor(value);
        this.imageWidthFinal  = Math.floor( this.imageWidth * value / 100 );
        this.imageHeightFinal = Math.floor( this.imageHeight * value / 100 );
    },
    onDownloadImage( image ) {
        const link   = document.createElement('a');
        var filename = image.srcElement.dataset.filename;
        link.href    = image.srcElement.href;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }
    //
  }
}
